import React, { useEffect, useState } from "react";
import {
  Modal,
  Button,
  Form,
  Spinner,
  Pagination,
  Row,
  Col,
  Container,
  Table,
} from "react-bootstrap";
import { BsArrowReturnLeft } from "react-icons/bs";
import { apiPost } from "../../service/admin/apiService";
import { showSuccess, showError } from "../../utils/toast";
import AdminScreenHeader from "../admin/adminScreenHeader";
import Loader from "../loader";

const UserMessage = () => {
  const [messageList, setMessageList] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [limit, setLimit] = useState(10);
  const [activePage, setActivePage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [showFullMsgId, setShowFullMsgId] = useState(null);
  const [loading, setLoading] = useState(false);
  const tk = localStorage.getItem("tk") || "";

  useEffect(() => {
    getUserMessage();
  }, []);

  const filteredMessage = messageList.filter((msg) => {
    const fullName = `${msg.ms}`.toLowerCase();
    const term = searchTerm.toLowerCase();
    return msg.ms.toLowerCase().includes(term) || fullName.includes(term);
  });

  useEffect(() => {
    const calculatedMaxPage = Math.ceil(filteredMessage.length / limit) || 1;
    setMaxPage(calculatedMaxPage);
    if (activePage > calculatedMaxPage) setActivePage(1);
  }, [filteredMessage, limit]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > maxPage) return;
    setActivePage(pageNumber);
  };

  useEffect(() => {
    if (messageList.length > 0) {
      console.log("messageList", messageList);
    }
  }, [messageList]);

  const getUserMessage = async () => {
    setShowLoader(true);
    const payload = {
      action: "getcadashboard",
      to: tk,
    };

    try {
      const response = await apiPost(process.env.REACT_APP_API_URL, payload);
      console.log("clients", response?.responsedetails);
      if (Number(response?.errordetails?.errorcode) > 0) {
        showError(response?.errordetails?.error);
      } else if (response?.responsedetails) {
        if (response?.responsedetails?.messages) {
          setMessageList(response?.responsedetails.messages || []);
          setTimeout(() => {
            setShowLoader(false);
          }, 3000);
        }
      }
    } catch (err) {
      setShowLoader(false);
      console.error("Error fetching client data to review", err);
    }
  };

  const showMsg = async (id) => {
    setShowFullMsgId(id);
    const payload = {
      action: "usermessageread",
      to: tk,
      id: id,
      ir: "yes",
    };

    try {
      const response = await apiPost(process.env.REACT_APP_API_URL, payload);
      console.log("msg read", response);
      if (Number(response?.errordetails?.errorcode) > 0) {
        showError(response?.errordetails?.error);
      } else if (response?.responsedetails) {
        if (response?.responsedetails?.messages) {
          setMessageList(response?.responsedetails.messages || []);
        }
      }
    } catch (err) {
      console.error("Error setting msg as read", err);
    }
  };

  const completeMsg = async (id) => {
    if (loading) return;
    setLoading(true);
    setShowFullMsgId(id);
    const payload = {
      action: "usermessagecomplete",
      to: tk,
      id: id,
      ic: "yes",
    };

    try {
      const response = await apiPost(process.env.REACT_APP_API_URL, payload);
      console.log("msgComplete", response);
      if (Number(response?.errordetails?.errorcode) > 0) {
        showError(response?.errordetails?.error);
        setLoading(false);
      } else if (response?.responsedetails?.success === "yes") {
        showSuccess("Task has been marked as completed.");
        setTimeout(() => {
          setLoading(false);
          getUserMessage();
        }, 2000);
      }
    } catch (err) {
      setLoading(false);
      console.error("Error setting msg to complete", err);
    }
  };

  const truncate = (text) => {
    return text.length > 50 ? text.slice(0, 50) + "..." : text;
  };

  return (
    <>
      <Container className="mt-4 ">
        {/* Desktop View */}
        <div className="d-none d-md-block mt-3">
          <AdminScreenHeader
            title="📋 Client Data"
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            placeholder="Search Client/Tan"
            showSearch={true}
          />

          <div
            className="fixed-table"
            style={{ maxHeight: "500px", overflowY: "auto" }}
          >
            <Table
              striped
              bordered
              hover
              responsive
              className="w-100 custom-table text-primary"
              style={{ verticalAlign: "middle" }}
            >
              <thead>
                <tr>
                  <th style={{ width: "65%" }}>Message</th>
                  <th style={{ textAlign: "center", width: "25%" }} colSpan="2">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredMessage
                  .slice((activePage - 1) * limit, activePage * limit)
                  .map((msg, index) => (
                    <>
                      <tr key={index}>
                        <td>{truncate(msg.ms)}</td>
                        <td style={{ textAlign: "center" }}>
                          <Button
                            size="sm"
                            variant="warning"
                            onClick={() => {
                              showMsg(msg.id);
                            }}
                          >
                            Show Message
                          </Button>
                        </td>
                        <td style={{ textAlign: "center" }}>
                          <Button
                            size="sm"
                            variant="success"
                            onClick={() => {
                              completeMsg(msg.id);
                            }}
                          >
                            {loading && showFullMsgId === msg.id ? (
                              <>
                                <Spinner
                                  animation="border"
                                  size="sm"
                                  className="me-2 "
                                />
                                Completing...
                              </>
                            ) : (
                              "Complete Task"
                            )}
                          </Button>
                        </td>
                      </tr>
                      {showFullMsgId === msg.id && (
                        <tr>
                          <td colSpan={3}>
                            <div
                              style={{
                                position: "relative",
                                border: "1px solid #ccc",
                                padding: "10px",
                                borderRadius: "5px",
                                backgroundColor: "#f9f9f9",
                              }}
                            >
                              <Button
                                variant="light"
                                size="sm"
                                style={{
                                  position: "absolute",
                                  left: "5px",
                                  top: "5px",
                                  padding: "0.25rem 0.5rem",
                                }}
                                onClick={() => setShowFullMsgId(null)}
                              >
                                ✖
                              </Button>
                              <Form.Control
                                as="textarea"
                                rows={3}
                                readOnly
                                value={msg.ms}
                                style={{ paddingLeft: "30px" }}
                              />
                            </div>
                          </td>
                        </tr>
                      )}
                    </>
                  ))}
              </tbody>
            </Table>
          </div>
          <Row className="mt-3 mb-3">
            <Col className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <label
                  className="me-2 mb-0"
                  style={{ color: "#0d6efd", fontSize: "13px" }}
                >
                  Records per page:
                </label>
                <Form.Select
                  value={limit}
                  onChange={(e) => {
                    const value =
                      e.target.value === "All"
                        ? filteredMessage.length
                        : parseInt(e.target.value);
                    setLimit(value);
                    setActivePage(1);
                  }}
                  style={{ width: "100px" }}
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100000">All</option>
                </Form.Select>
              </div>

              {/* Pagination */}
              <Pagination className="mb-0">
                <Pagination.First
                  onClick={() => handlePageChange(1)}
                  disabled={activePage === 1}
                />
                <Pagination.Prev
                  onClick={() => handlePageChange(activePage - 1)}
                  disabled={activePage === 1}
                />
                <Pagination.Item>
                  {`Page ${activePage} of ${maxPage}`}
                </Pagination.Item>
                <Pagination.Next
                  onClick={() => handlePageChange(activePage + 1)}
                  disabled={activePage >= maxPage}
                />
                <Pagination.Last
                  onClick={() => handlePageChange(maxPage)}
                  disabled={activePage >= maxPage}
                />
              </Pagination>
            </Col>
          </Row>
        </div>
        {showLoader ? <Loader show={showLoader} /> : null}
      </Container>
    </>
  );
};

export default UserMessage;
